import { render, staticRenderFns } from "./ModalAddEditArticleSource.vue?vue&type=template&id=5d1586a4"
import script from "./ModalAddEditArticleSource.vue?vue&type=script&lang=js"
export * from "./ModalAddEditArticleSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports